import { Translate } from 'react-redux-i18n'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { formatText } from '../../../../helpers/value'
import { TITLE_TABLE_DETAIL } from '../constant'
import { CustomTdActionDetail } from './CustomTdActionDetail'
import { CustomTdAlertDetail } from './CustomTdAlertDetail'
import { CustomTdStatus } from './CustomTdStatus'
import { CustomTdTitleDetailTable } from './CustomTdTitleDetailTable'
import { CustomThTitleDetailTable } from './CustomThTitleDetailTable'
import { CustomThTooltip } from './CustomThTooltip'

export const getSchemaTableDetailsPortfolio = () =>
  TITLE_TABLE_DETAIL.map((item, index) => {
    const result = {
      title: <Translate value={item.label} />,
      colId: item.key,
      thStyle: {
        textAlign: 'left',
      },
      tdStyle: {
        textAlign: 'left',
      },
    }
    if (index === 0) {
      return {
        title: <CustomThTitleDetailTable item={item.label} />,
        colId: item.key,
        thStyle: {
          textAlign: 'left',
          width: '100%',
        },
        tdStyle: {
          textAlign: 'left',
          padding: 0,
        },
        render: (val, { rowId }) => {
          return <CustomTdTitleDetailTable item={val} rowId={rowId} />
        },
      }
    }
    if (index === 2) {
      return {
        ...result,
        sortable: true,
        render: (val, { rowId }) => {
          return <CustomTdStatus val={val} />
        },
      }
    }
    if (index === 3) {
      return {
        ...result,
        sortable: true,
        render: (val, { rowId }) => {
          return <CustomTdAlertDetail val={val} rowId={rowId} />
        },
      }
    }
    if (index === 4) {
      return {
        ...result,
        title: <CustomThTooltip value={item.label} />,
        sortable: true,
        render: (val, { locale }) => {
          return formatDateTime(val, FORMAT.DATE, locale)
        },
      }
    }
    if (index === 5) {
      return {
        ...result,
        render: (val, { rowId }) => {
          return <CustomTdActionDetail rowId={rowId} />
        },
      }
    }
    return {
      ...result,
      render: (val) => {
        return formatText(val)
      },
    }
  })
